import { TEXT_CORE_DISPLAY_NAME } from "./core";
import createTestId from "../../../../fabrics/createTestId";

export const createTestIdForTextCoreElement = createTestId(
    TEXT_CORE_DISPLAY_NAME,
);
